[
  {
    "source": "Substack",
    "title": "Welcome to the feed",
    "excerpt": "Essays, notes, and ideas — latest writing from the blog.",
    "url": "https://aj91.substack.com/",
    "thumbnail": "",
    "publishedAt": "2025-01-15T12:00:00.000Z"
  },
  {
    "source": "Hashnode",
    "title": "Latest from the blog",
    "excerpt": "Posts and ideas from aj91.hashnode.dev.",
    "url": "https://aj91.hashnode.dev/",
    "thumbnail": "",
    "publishedAt": "2025-01-10T09:00:00.000Z"
  }
]
